/* eslint react/prop-types: 0 */
import React, { useMemo } from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';

import { mapIconListForGoogleMap } from '../../../consts/mapIconList';

import './styles.scss';

const MarkerListFullEditor = ({
  markerSettings = [],
  setMarkerSettings,
  selectList = [],
  selectedRowIndex,
  setSelectedRowIndex,
  className,
  onEditMode,
  defaultMarker
}) => {
  const availableSelectItems = useMemo(() => {
    return selectList.filter((item) => {
      return !markerSettings.some((marker) => marker?.id === item.id);
    });
  }, [selectList, markerSettings]);

  const onEditHandler = (index) => {
    if (index === selectedRowIndex) {
      setSelectedRowIndex(null);
    } else {
      setSelectedRowIndex(index);
    }
  };

  const onDeleteHandler = (index) => {
    setMarkerSettings((prev) => {
      const newList = [...prev];
      newList.splice(index, 1);
      return newList;
    });
    setSelectedRowIndex(null);
  };

  const addItem = () => {
    setMarkerSettings((prev) => [...prev, { id: null }]);
  };

  return (
    <List className={`MarkerListFullEditor-root ${className}`}>
      {markerSettings.map((markerSetting, index) => {
        const fillColor =
          markerSetting?.color || defaultMarker?.color || '#333';
        const style = markerSetting?.style || defaultMarker?.style || 'circle';
        const iconIdx = markerSetting?.icon ?? defaultMarker?.icon ?? 0;

        return (
          <ListItem key={index} divider disableGutters>
            <ListItemIcon>
              <img
                className="MarkerListFullEditor-itemIcon"
                alt="marker"
                src={mapIconListForGoogleMap(fillColor, style)[iconIdx]}
              />
            </ListItemIcon>
            {!onEditMode && (
              <ListItemText className="MarkerListFullEditor-itemText">
                {selectList.find(
                  (selectItem) => selectItem.id === markerSetting?.id
                )?.name || 'No Item Selected'}
              </ListItemText>
            )}
            {onEditMode ? (
              <>
                <Autocomplete
                  options={availableSelectItems}
                  className={'MarkerListFullEditor-autoComplete'}
                  getOptionLabel={(option) => option.name}
                  value={
                    selectList.find(
                      (selectItem) => selectItem.id === markerSetting?.id
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    const newId = newValue ? newValue.id : null;

                    setMarkerSettings((list) => {
                      const newList = [...list];
                      newList[index] = { ...newList[index], id: newId };
                      return newList;
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={'Select Option'} />
                  )}
                />
                <IconButton
                  aria-label={`Edit marker ${index + 1}`}
                  onClick={() => {
                    onEditHandler(index);
                  }}
                >
                  <EditIcon
                    fontSize={'small'}
                    className={
                      index === selectedRowIndex
                        ? 'MarkerListFullEditor-selectedRow'
                        : 'MarkerListFullEditor-penIcon'
                    }
                  />
                </IconButton>
                <IconButton
                  aria-label={`Delete marker ${index + 1}`}
                  edge="end"
                  onClick={() => onDeleteHandler(index)}
                >
                  <DeleteIcon
                    fontSize={'small'}
                    className="MarkerListFullEditor-deleteIcon"
                  />
                </IconButton>
              </>
            ) : null}
          </ListItem>
        );
      })}
      <ListItem>
        {onEditMode && markerSettings.length < selectList.length && (
          <Button startIcon={<AddIcon />} onClick={addItem}>
            Add New
          </Button>
        )}
      </ListItem>
    </List>
  );
};

export default MarkerListFullEditor;
